export default {
  path: '/settings',
  name: 'Settings',
  component: () => import('../views/layouts/Default.layout.vue'),
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: 'notifications',
      name: 'NotificationSetting',
      component: () =>
        import('../views/pages/Employee/NotificationSetting.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
}
